<template>
  <v-container fluid grid-list-sm>
    <v-card v-if="mode === 'list'">
      <v-toolbar :dense="true" >
        <v-toolbar-title class="body-2"> <v-icon>mdi-cash-multiple</v-icon> Payments </v-toolbar-title>
        <v-spacer />
        <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
      </v-toolbar>
      <v-data-table :headers="paymentColumns" :items="payments" class="elevation-1" :footer-props="{'items-per-page-options': itemsPerPage }" >
        <template v-slot:item="row"
          ><tr>
            <td>{{ row.item.clmtNo }}</td>
            <td>{{ row.item.clmItem }}</td>
            <td>{{ row.item.clmResCat }}</td>
            <td>{{ row.item.status }}</td>
            <td>{{ formatDisplayDate(row.item.tranDate) }}</td>
            <td>{{ row.item.acctMth }}</td>
            <td>{{ row.item.acctYr }}</td>
            <td>{{ formatBoolean(row.item.tranRel) }}</td>
            <td>{{ row.item.tranType }}</td>
            <td>{{ row.item.docNo }}</td>
            <td>{{ row.item.curr }}</td>
            <td class="text-right">{{ row.item.paytAmt }}</td>
            <td class="text-right">{{ row.item.paytAmtRes }}</td>
            <td>{{ formatBoolean(row.item.docPrtd) }}</td>
            <td>{{ formatDateTime2(row.item.createdDate) }}</td>
            <td>{{ row.item.usrRefId }}</td>
            <td>
              <v-btn icon>
                <v-icon
                  color="primary"
                  @click.prevent="goToPaymentDetail(commonInfo.clmNo, row.item.clmtNo, row.item.clmItem, row.item.tranType, row.item.docNo)"
                  >mdi-information-outline</v-icon
                >
              </v-btn>
            </td>
          </tr></template
        >
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red darken-1" text @click.native="doClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
export default {
  props: {},
  data() {
    return {
      loading: false,
      mode: 'list',
      paymentColumns: [
        { text: 'Clmt No', align: 'left', value: 'clmtNo' },
        { text: 'Item', align: 'left', value: 'clmItem' },
        { text: 'Payt Catg', align: 'left', value: 'clmResCat' },
        { text: 'Status', align: 'left', value: 'status' },
        { text: 'Tran Date', align: 'left', value: 'tranDate' },
        { text: 'Acct Month', align: 'left', value: 'acctMth' },
        { text: 'Acct Year', align: 'left', value: 'acctYr' },
        { text: 'TranRel', align: 'left', value: 'tranRel' },
        { text: 'Tran Type', align: 'left', value: 'tranType' },
        { text: 'Doc No', align: 'left', value: 'docNo' },
        { text: 'Payt Curr', align: 'left', value: 'curr' },
        { text: 'Payt Amt', align: 'left', value: 'paytAmt' },
        { text: 'Payt Amt Res', align: 'left', value: 'paytAmtRes' },
        { text: 'Doc Printed', align: 'left', value: 'docPrtd' },
        { text: 'Entry Date', align: 'left', value: 'createdDate' },
        { text: 'User ID', align: 'left', value: 'createdBy' },
        { text: 'Details', align: 'left', value: 'details' }
      ]
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    payments() {
      return this.commonInfo.clmPayts
    }
  },
  methods: {
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    },
    doClose() {
      this.$emit('close')
    },
    formatDisplayDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return ''
      }
    },
    async goToPaymentDetail(clmNo, clmtNo, clmItem, tranType, docNo) {
      this.$router.push({ name: 'qClaimPayment', params: { clmNo: clmNo, clmtNo: clmtNo, clmItem: clmItem, docNo: docNo, tranType: tranType } })
      this.doClose()
    }
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>

<style>
</style>
